export const READY = "ready_takephoto";
export const START = "start_takephoto";
export const UPLOADING = "uploading";
export const UPLOADED = "uploaded";
